import * as React from "react";
import { Button, Form, Row } from "antd";
import { ISection } from "../../../model/formconfiguration/Section";
import FormSection from "./FormSection";
import UpdateSectionForm, { UpdateSectionFormProps } from "./UpdateSectionForm";
import RemoveSectionModal from "./RemoveSectionModal";
import FormParamsBox from "./FormParamsBox";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import { IFormType } from "../../../model/formconfiguration/FormType";
import { FormTypeConstants } from "../../../common/Constants";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";
import UpdateFormConfigSectionQualifierForm, {
  UpdateFormConfigSectionQualifierFormProps
} from "./UpdateFormConfigSectionQualifierForm";
import UpdateFormConfigQualifierAttributeForm, {
  UpdateFormConfigQualifierAttributeFormProps
} from "./UpdateFormConfigQualifierAttributeForm";

export interface State {
  removeSectionModalVisible: boolean;
  parentSectionId?: Number;
  addQualifierModalVisible: boolean;
  removeQualifierModalVisible: boolean;
  addAttributeModalVisible: boolean;
  invalidateAttributeModalVisible: boolean;
}

export interface Props {
  formTitle?: string;
  formSections?: ISection[];
  createSection?: any;
  translate: any;
  updateSection: any;
  removeSection: any;
  setSelectedFormElement: any;
  selectedFormElement?: ISection;
  createFormConfigSectionQualifier(
    parentFormSection: ISection,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): any;
  qualifiers?: any;
  updateFormConfigSectionQualifier(
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): any;
  invalidateQualifier: any;
  createFormConfigQualifierAttribute(
    parentFormConifgSectionQualifier: IFormConfigSectionQualifier,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  attributes?: IAttribute[];
  updateFormConfigQualifierAttribute(
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  invalidateAttribute: any;
  isSelectedComponent: any;
  loading?: boolean;
  updateFormConfigurationLoading?: boolean;
  formParamsBoxVisible: boolean;
  hideFormParamsBox: any;
  formType: IFormType;
}

export default class FormConfiguration extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      removeSectionModalVisible: false,
      parentSectionId: undefined,
      addQualifierModalVisible: false,
      removeQualifierModalVisible: false,
      addAttributeModalVisible: false,
      invalidateAttributeModalVisible: false
    };
  }
  private showRemoveSectionModal = () => {
    this.setState({ removeSectionModalVisible: true });
  };

  private hideRemoveSectionModal = () => {
    this.setState({ removeSectionModalVisible: false });
  };

  private onRemoveSectionClick = () => {
    this.showRemoveSectionModal();
  };

  private showAddQualifierModal = () => {
    this.setState({ addQualifierModalVisible: true });
  };

  private hideAddQualifierModal = () => {
    this.setState({ addQualifierModalVisible: false });
  };

  private showRemoveQualifierModal = () => {
    this.setState({ removeQualifierModalVisible: true });
  };

  private hideRemoveQualifierModal = () => {
    this.setState({ removeQualifierModalVisible: false });
  };

  private showAddAttributeModal = () => {
    this.setState({ addAttributeModalVisible: true });
  };

  private hideAddAttributeModal = () => {
    this.setState({ addAttributeModalVisible: false });
  };

  private showInvalidateAttributeModal = () => {
    this.setState({ invalidateAttributeModalVisible: true });
  };

  private hideInvalidateAttributeModal = () => {
    this.setState({ invalidateAttributeModalVisible: false });
  };

  private onRemoveSectionSubmit() {
    const { removeSection, selectedFormElement } = this.props;
    removeSection(selectedFormElement && selectedFormElement.id);
    this.hideRemoveSectionModal();
  }

  private onSectionClick = (section: ISection) => {
    this.props.setSelectedFormElement(section);
  };

  render() {
    const {
      formTitle,
      formSections,
      translate,
      selectedFormElement,
      updateSection,
      createSection,
      createFormConfigSectionQualifier,
      qualifiers,
      updateFormConfigSectionQualifier,
      invalidateQualifier,
      createFormConfigQualifierAttribute,
      attributes,
      updateFormConfigQualifierAttribute,
      invalidateAttribute,
      isSelectedComponent,
      loading,
      formParamsBoxVisible,
      hideFormParamsBox,
      formType
    } = this.props;

    const UpdateSection = Form.create<UpdateSectionFormProps>({})(
      UpdateSectionForm
    );

    const UpdateQualifier = Form.create<
      UpdateFormConfigSectionQualifierFormProps
    >({})(UpdateFormConfigSectionQualifierForm);

    const UpdateAttribute = Form.create<
      UpdateFormConfigQualifierAttributeFormProps
    >({})(UpdateFormConfigQualifierAttributeForm);

    const renderSections = () => {
      let formSectionsRendered: JSX.Element[] = [];
      if (formSections) {
        formSections.sort(function (a, b) {
          return a.orderNumber - b.orderNumber;
        });
        formSections.forEach((section) => {
          formSectionsRendered.push(
            <Row>
              <FormSection
                key={section.id}
                translate={translate}
                section={section}
                onRemoveBtnClick={this.onRemoveSectionClick}
                onCreateBtnClick={createSection}
                onClick={this.onSectionClick}
                selectedFormElement={selectedFormElement}
                createFormConfigSectionQualifier={
                  createFormConfigSectionQualifier
                }
                qualifiers={qualifiers}
                invalidateQualifier={invalidateQualifier}
                createFormConfigQualifierAttribute={
                  createFormConfigQualifierAttribute
                }
                attributes={attributes}
                invalidateAttribute={invalidateAttribute}
                addQualifierModalVisible={
                  this.state && this.state.addQualifierModalVisible
                }
                showAddQualifierModal={this.showAddQualifierModal}
                hideAddQualifierModal={this.hideAddQualifierModal}
                showAddAttributeModal={this.showAddAttributeModal}
                hideAddAttributeModal={this.hideAddAttributeModal}
                showRemoveQualifierModal={this.showRemoveQualifierModal}
                hideRemoveQualifierModal={this.hideRemoveQualifierModal}
                addAttributeModalVisible={
                  this.state && this.state.addAttributeModalVisible
                }
                removeQualifierModalVisible={
                  this.state && this.state.removeQualifierModalVisible
                }
                hideInvalidateAttributeModal={this.hideInvalidateAttributeModal}
                invalidateAttributeModalVisible={
                  this.state && this.state.invalidateAttributeModalVisible
                }
                isSelectedComponent={isSelectedComponent}
              />
            </Row>
          );
        });
        return formSectionsRendered;
      }
    };

    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          background: "yellow"
        }}
      >
        <div
          style={{
            position: "relative",
            float: "left",
            width: formParamsBoxVisible ? "75%" : "100%",
            padding: 20
          }}
        >
          <h2>{formTitle}</h2>
          <RemoveSectionModal
            translate={translate}
            visible={this.state && this.state.removeSectionModalVisible}
            onCancel={() => this.hideRemoveSectionModal()}
            onOk={(e) => this.onRemoveSectionSubmit()}
          >
            <p>{translate("remove_section_modal.text")}</p>
          </RemoveSectionModal>
          {renderSections()}
          {!loading &&
            formType.status === FormTypeConstants.STATUS.PREPARATION && (
              <Button
                block={true}
                size="large"
                type="dashed"
                icon="plus"
                onClick={() => createSection(undefined)}
              >
                {translate("main_form.createSection")}
              </Button>
            )}
        </div>
        {formParamsBoxVisible && (
          <div
            style={{
              position: "fixed",
              width: "20%",
              height: "calc(100% - 60)",
              right: 0,
              bottom: 0,
              top: 60
            }}
          >
            <FormParamsBox
              translate={translate}
              UpdateSectionForm={UpdateSection}
              selectedFormElement={selectedFormElement}
              onUpdateSection={updateSection}
              updateFormConfigSectionQualifier={
                updateFormConfigSectionQualifier
              }
              UpdateQualifierForm={UpdateQualifier}
              UpdateAttributeForm={UpdateAttribute}
              updateFormConfigQualifierAttribute={
                updateFormConfigQualifierAttribute
              }
              showAddQualifierModal={this.showAddQualifierModal}
              createSection={createSection}
              showRemoveSectionModal={this.showRemoveSectionModal}
              showRemoveQualifierModal={this.showRemoveQualifierModal}
              showAddAttributeModal={this.showAddAttributeModal}
              showInvalidateAttributeModal={this.showInvalidateAttributeModal}
              hideFormParamsBox={hideFormParamsBox}
              readOnly={
                formType.status !== FormTypeConstants.STATUS.PREPARATION
              }
            />
          </div>
        )}
      </div>
    );
  }
}
